import { render, staticRenderFns } from "./CommentTypeSelect.vue?vue&type=template&id=6c2c0b13"
import script from "./CommentTypeSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentTypeSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CommentTypeSelect.vue?vue&type=style&index=0&id=6c2c0b13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports